<app-header></app-header>

<main class="main lighting-container">

    <div class="container page-head">
        <h2 class="header">Contact Us</h2>
    </div>


    <div class="container">
        <div class="lighting-card lighting" appLightingHover>
            <div class="lighting-card-wrap">
                <section class="form-wrap">
                    <h3 class="header">
                        Complete the form below & we will reach out to you shortly
                    </h3>

                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                        <div class="controls-wrap">
                            <div class="group-control">
                                <label for="username">Name</label>
                                <input
                                    type="text"
                                    class="control"
                                    placeholder="Enter your Name"
                                    id="username"
                                    formControlName="username"
                                >
                                <ng-container *ngIf="username?.invalid && (username?.dirty || username?.touched)">
                                    <p class="error"
                                       *ngIf="username?.errors?.required && !username?.errors?.invalidCharacters ">
                                        This field is required.
                                    </p>
                                    <p class="error"
                                       *ngIf="username?.errors?.invalidCharacters && !username?.errors?.required">
                                        Name must contain only letters.
                                    </p>
                                    <p class="error"
                                       *ngIf="username?.touched && username?.errors?.tooShort && !username?.errors?.invalidCharacters && !username?.errors?.required">
                                        Name must be 3-16 letters.
                                    </p>
                                </ng-container>

                            </div>
                            <div class="group-control">
                                <label for="contact">Telegram or mobile*</label>
                                <input
                                    type="tel"
                                    inputmode="tel"
                                    class="control"
                                    placeholder="Enter your Telegram or mobile"
                                    id="contact"
                                    formControlName="contact"
                                >
                                <ng-container *ngIf="contact?.invalid && (contact?.dirty || contact?.touched)">
                                    <p class="error" *ngIf="contact?.errors?.required">
                                        This field is required.
                                    </p>
                                </ng-container>
                            </div>
                            <div class="group-control">
                                <label for="company">Company</label>
                                <input
                                    type="text"
                                    class="control"
                                    placeholder="Enter your Company"
                                    id="company"
                                    formControlName="company"
                                >
                            </div>
                            <div class="group-control">
                                <label for="email">Email</label>
                                <input
                                    type="email"
                                    inputmode="email"
                                    class="control"
                                    placeholder="Enter your Email"
                                    id="email"
                                    formControlName="email"
                                >
                                <ng-container *ngIf="email?.invalid && (email?.dirty || email?.touched)">
                                    <p class="error" *ngIf="email?.touched && email?.errors?.email ">
                                        Email is entered incorrectly.
                                    </p>
                                </ng-container>
                            </div>
                            <div class="group-control textarea-wrap">
                                <label for="msg">Message</label>
                                <textarea
                                    class="control"
                                    placeholder="What would you like to discuss with Forest Staking?"
                                    id="msg"
                                    name="msg"
                                    rows="4"
                                    cols="50"
                                    formControlName="msg"
                                ></textarea>
                                <ng-container *ngIf="msg?.invalid && (msg?.dirty || msg?.touched)">
                                    <p class="error" *ngIf="msg?.errors?.required ">
                                        This field is required.
                                    </p>
                                </ng-container>
                            </div>

                        </div>
                        <div class="control-wrap">
                            <label>By clicking the "Send message" button, you confirm your consent to the processing of
                                user data.</label>
                            <button class="btn btn-l btn-outlined btn-extra"
                                    type="submit"
                                    [disabled]="contactForm.invalid"
                            >
                                Send message
                                <svg width="21" height="21" viewBox="0 0 21 21" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.30776 11.6932L14.1539 6.84704M19.1113 3.88952L15.0207 17.1841C14.6539 18.3759 14.4707 18.9718 14.1544 19.1694C13.8802 19.3407 13.5403 19.3689 13.2416 19.2449C12.8972 19.102 12.618 18.5444 12.0603 17.4291L9.46938 12.2472C9.38089 12.0702 9.3366 11.9817 9.27749 11.905C9.22504 11.837 9.16428 11.7759 9.09623 11.7235C9.01954 11.6644 8.93082 11.6201 8.75383 11.5316L3.57192 8.94067C2.45662 8.38302 1.89892 8.1043 1.75601 7.75988C1.63207 7.46119 1.66033 7.1209 1.83169 6.84664C2.02928 6.53041 2.62523 6.34712 3.81704 5.98041L17.1116 1.88977C18.0486 1.60147 18.5169 1.4573 18.8334 1.57349C19.1091 1.67469 19.3265 1.89194 19.4277 2.1676C19.5439 2.48408 19.3996 2.95257 19.1113 3.88952Z"
                                        stroke="#0C1117" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </form>
                </section>
                <ng-container *ngIf="openLoader">
                    <div class="loader-form">
                        <div class="inner-wrap">
                            <ng-container *ngIf="statusSending">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="40" cy="40" r="40" fill="#13CE67" fill-opacity="0.1"/>
                                    <path d="M29.333 39.9995L35.9327 46.5992L50.0754 32.457" stroke="#13CE67"
                                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </ng-container>

                            <ng-container *ngIf="!statusSending">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect width="80" height="80" rx="40" fill="#EE505A" fill-opacity="0.1"/>
                                    <path
                                        d="M28.5684 44.8002L29.4344 45.3002L28.5684 44.8002ZM35.843 32.2002L34.9769 31.7002V31.7002L35.843 32.2002ZM44.1572 32.2002L45.0233 31.7002L44.1572 32.2002ZM51.4318 44.8002L52.2979 44.3002L51.4318 44.8002ZM38.7795 28.2594L39.1862 29.1729L38.7795 28.2594ZM41.2202 28.2594L40.8135 29.1729L41.2202 28.2594ZM27.8447 51.4271L27.2569 52.2362H27.2569L27.8447 51.4271ZM26.6242 49.3136L27.6187 49.2091L26.6242 49.3136ZM52.1555 51.4271L52.7432 52.2362L52.1555 51.4271ZM53.376 49.3136L54.3705 49.4181L53.376 49.3136ZM40.0747 46.0001H41.0747C41.0747 45.4478 40.627 45.0001 40.0747 45.0001V46.0001ZM40.0747 46.1501L40.0745 47.1501C40.3397 47.1502 40.5941 47.0448 40.7817 46.8573C40.9693 46.6697 41.0747 46.4153 41.0747 46.1501H40.0747ZM39.9253 46.15H38.9253C38.9253 46.7022 39.3729 47.1499 39.925 47.15L39.9253 46.15ZM39.9253 46.0001V45.0001C39.373 45.0001 38.9253 45.4478 38.9253 46.0001H39.9253ZM41 35.5001C41 34.9478 40.5523 34.5001 40 34.5001C39.4477 34.5001 39 34.9478 39 35.5001H41ZM39 41.5001C39 42.0524 39.4477 42.5001 40 42.5001C40.5523 42.5001 41 42.0524 41 41.5001H39ZM47.2748 51.0001H32.7256V53.0001H47.2748V51.0001ZM29.4344 45.3002L36.709 32.7002L34.9769 31.7002L27.7023 44.3002L29.4344 45.3002ZM43.2912 32.7002L50.5658 45.3002L52.2979 44.3002L45.0233 31.7002L43.2912 32.7002ZM36.709 32.7002C37.401 31.5017 37.8861 30.6633 38.3056 30.0694C38.7282 29.4711 38.9927 29.2591 39.1862 29.1729L38.3728 27.3458C37.6758 27.6561 37.1541 28.2331 36.6721 28.9154C36.187 29.6021 35.6491 30.5359 34.9769 31.7002L36.709 32.7002ZM45.0233 31.7002C44.351 30.5358 43.813 29.602 43.3278 28.9153C42.8456 28.2329 42.3238 27.6561 41.627 27.3458L40.8135 29.1729C41.0071 29.2591 41.2717 29.4713 41.6944 30.0695C42.1141 30.6634 42.5993 31.5017 43.2912 32.7002L45.0233 31.7002ZM39.1862 29.1729C39.704 28.9424 40.2957 28.9424 40.8135 29.1729L41.627 27.3458C40.5913 26.8847 39.4084 26.8847 38.3728 27.3458L39.1862 29.1729ZM32.7256 51.0001C31.3417 51.0001 30.3732 50.9991 29.6491 50.9327C28.9199 50.8658 28.604 50.7427 28.4325 50.6181L27.2569 52.2362C27.8741 52.6846 28.6344 52.848 29.4664 52.9243C30.3035 53.0011 31.3812 53.0001 32.7256 53.0001V51.0001ZM27.7023 44.3002C27.0301 45.4645 26.4905 46.3972 26.1384 47.1606C25.7886 47.9193 25.55 48.6595 25.6297 49.4181L27.6187 49.2091C27.5966 48.9983 27.648 48.6631 27.9546 47.9981C28.2591 47.3379 28.7425 46.4986 29.4344 45.3002L27.7023 44.3002ZM28.4325 50.6181C27.9738 50.2849 27.678 49.7726 27.6187 49.2091L25.6297 49.4181C25.7482 50.5457 26.34 51.5699 27.2569 52.2362L28.4325 50.6181ZM47.2748 53.0001C48.6192 53.0001 49.6968 53.0011 50.5339 52.9243C51.3658 52.848 52.1261 52.6845 52.7432 52.2362L51.5677 50.6181C51.3962 50.7427 51.0803 50.8658 50.3512 50.9327C49.6271 50.9991 48.6587 51.0001 47.2748 51.0001V53.0001ZM50.5658 45.3002C51.2577 46.4986 51.7411 47.3379 52.0456 47.9981C52.3522 48.6631 52.4036 48.9983 52.3815 49.2091L54.3705 49.4181C54.4502 48.6595 54.2116 47.9193 53.8618 47.1606C53.5097 46.3972 52.9701 45.4645 52.2979 44.3002L50.5658 45.3002ZM52.7432 52.2362C53.6602 51.5699 54.252 50.5457 54.3705 49.4181L52.3815 49.2091C52.3222 49.7726 52.0264 50.2849 51.5677 50.6181L52.7432 52.2362ZM39.0747 46.0001V46.1501H41.0747V46.0001H39.0747ZM40.075 45.1501L39.9255 45.15L39.925 47.15L40.0745 47.1501L40.075 45.1501ZM40.9253 46.15V46.0001H38.9253V46.15H40.9253ZM39.9253 47.0001H40.0747V45.0001H39.9253V47.0001ZM39 35.5001V41.5001H41V35.5001H39Z"
                                        fill="#EE505A"/>
                                </svg>
                            </ng-container>

                            <h3 class="header">{{ statusSending ? 'Your request has been sent.' : 'Oops!' }}</h3>
                            <p class="description">{{ statusSending ? 'We will reach out to you shortly' : 'Something went wrong, please try again' }}</p>
                            <button class="btn btn-outlined btn-m" (click)="handler()">
                                {{ statusSending ? 'Back to Home' : 'Try again' }}
                            </button>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="container container-fix">
        <app-baner></app-baner>
    </div>

</main>

<app-footer></app-footer>

